/**
 * Décisions 360 et 404 (TL, 30/10) — un ayant droit ajouté au guichet,
 * conjoint ou enfant, entre tout de suite, sans passer par la chargée de
 * clientèle, quand tout ce qu'elle vérifierait est déjà acquis sur la
 * plateforme.
 *
 * Conditions cumulées, toutes lues par le serveur (décision 362 : pas de case
 * « Carte présentée », toute personne qui se présente a sa carte) :
 * - le salarié figure au DNS en cours de son contrat actuel (dernier DNS
 *   complet appliqué), actif et confirmé (décision 363, C2) ;
 * - l'entreprise n'est ni suspendue ni résiliée (`entrepriseCouvre`) ;
 * - pour un enfant seulement : l'âge est dans la limite de l'entreprise
 *   (21 ans, 25 pour la BRED) ;
 * - pour un enfant (décision 361) : le salarié n'a pas déjà autant d'enfants
 *   que le DNS en déclare. Au-delà, la décision revient à la chargée (garder
 *   les deux, ou retirer l'ancien), comme pour la confirmation sur pièce ;
 * - pour un conjoint (décision 406) : le salarié n'a pas déjà un conjoint
 *   enregistré (actif, non infirmé, non supprimé). Un seul conjoint entre
 *   directement ; le DNS n'est pas consulté, beaucoup n'ont pas la colonne.
 *
 * La date de naissance n'est plus une condition (décisions 404 et 407) :
 * l'accueil la saisit, elle est obligatoire à l'ajout d'un enfant.
 *
 * Il manque une condition : la fiche reste « à confirmer » comme avant, et
 * l'écran dit laquelle. Pure et partagée : l'API décide avec elle, l'écran
 * l'explique avec les mêmes mots. `VERIFICATION_IMPOSSIBLE` ne vient pas de
 * la règle : le serveur la pose quand il n'a pas pu examiner à temps
 * (décision 363, C1) — l'accueil n'attend jamais.
 */
import { depasseLeDns } from './ayants-droit.js';
import { AGE_LIMITE_ENFANT, enfantAuDelaDeLAge, entrepriseCouvre } from './eligibilite.js';
export const CONDITIONS_AYANT_DROIT_SANS_CONFIRMATION = [
    'SALARIE_ABSENT_DU_DNS',
    'ENTREPRISE_NE_COUVRE_PAS',
    'AGE_DEPASSE',
    'AU_DELA_DU_DNS',
    'CONJOINT_DEJA_ENREGISTRE',
    'VERIFICATION_IMPOSSIBLE',
];
export function ayantDroitSansConfirmation(ctx) {
    const manque = [];
    if (!ctx.salarieAuDnsEnCours)
        manque.push('SALARIE_ABSENT_DU_DNS');
    if (ctx.statutAdherent === null || !entrepriseCouvre(ctx.statutAdherent)) {
        manque.push('ENTREPRISE_NE_COUVRE_PAS');
    }
    if (ctx.lien === 'ENFANT' &&
        enfantAuDelaDeLAge(ctx.dateNaissance, ctx.aujourdHui, ctx.ageLimiteEnfant)) {
        manque.push('AGE_DEPASSE');
    }
    if (ctx.lien === 'ENFANT' && depasseLeDns(ctx.autresDuMemeLien, ctx.enfantsDeclares)) {
        manque.push('AU_DELA_DU_DNS');
    }
    if (ctx.lien === 'CONJOINT' && ctx.autresDuMemeLien > 0) {
        manque.push('CONJOINT_DEJA_ENREGISTRE');
    }
    return { admis: manque.length === 0, manque };
}
/** Ce que l'accueil lit, condition par condition, quand l'ayant droit attend la chargée. */
export function libelleConditionAyantDroit(condition, ageLimiteEnfant = AGE_LIMITE_ENFANT) {
    switch (condition) {
        case 'SALARIE_ABSENT_DU_DNS':
            return 'le salarié ne figure pas au dernier DNS de son contrat';
        case 'ENTREPRISE_NE_COUVRE_PAS':
            return 'l’entreprise est suspendue ou résiliée';
        case 'AGE_DEPASSE':
            return `l’enfant dépasse l’âge limite de son entreprise (${String(ageLimiteEnfant)} ans)`;
        case 'AU_DELA_DU_DNS':
            return 'le salarié a déjà autant d’enfants que son DNS en déclare';
        case 'CONJOINT_DEJA_ENREGISTRE':
            return 'le salarié a déjà un conjoint enregistré';
        case 'VERIFICATION_IMPOSSIBLE':
            return 'la vérification n’a pas pu se faire tout de suite (un autre poste enregistre un ayant droit de ce salarié)';
    }
}
//# sourceMappingURL=ayant-droit-sans-confirmation.js.map